<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <nav>
                    <span><b>ETAPA:</b>{{ desripcionEtapa }} <br />
              <b>HITOS REQUERIDOS:</b> {{ maximoHitosEtapa }}</span>
                </nav>
            </div>

            <div class="container card-body table-responsive pt-2">
                <div class="row mb-2" *hasDenied="{nivel:idSprNivel, app: constant.PROYECTOS}">
                    <div class="col-sm-6 text-sm-right">
                        <button *hasPermission="{ app: constant.PROYECTOS, permission: [constant.CREAR] }" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()">
                        <i class="fas fa-plus fa-lg mr-1"></i>Nuevo</button>
                    </div>
                </div>
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th class="etapa-column">Hito</th>
                            <th>Fecha comprometida</th>
                            <th>Peso</th>
                            <th>Cumplimiento</th>
                            <th>Semáforo</th>
                            <th>Fecha Cumplimiento</th>
                            <th class="text-center">Documento de soporte</th>
                            <th>Seguimiento</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let row of dataHito; let indice = index">
                            <td>{{ indice + 1 }}</td>
                            <td>{{ row.nombre }}</td>
                            <td>{{ row.fechaComprometida | date : "dd-MM-yyyy" }}</td>
                            <td>{{ row.peso }} %</td>
                            <td *ngIf="row.cumplidoHito === 'S' && row.respaldoPdf != null">
                                <p class="text-success text-center col-sm-auto">Si</p>
                            </td>

                            <td *ngIf="row.cumplidoHito === 'S' && row.respaldoPdf != null">
                                <p class="text-center col-sm-auto">
                                    <i class="fa fa-circle m-r-20 fa-lg" style="color: green"></i>
                                </p>
                            </td>

                            <td *ngIf="row.cumplidoHito === 'N' || row.respaldoPdf == null">
                                <p class="text-danger text-center col-sm-auto">No</p>
                            </td>

                            <td *ngIf="row.cumplidoHito === 'N' || row.respaldoPdf == null">
                                <p class="text-center col-sm-auto">
                                    <i class="fa fa-circle m-r-10 fa-lg" style="color: red"></i>
                                </p>
                            </td>

                            <td>
                                <div *ngIf="row.respaldoPdf != null">
                                    {{ row.fecha | date : "dd-MM-yyy" }}
                                </div>
                            </td>

                            <td class="plan-column" style=" max-width: 300px; word-wrap: break-word; white-space: normal; ">
                                <div *ngIf="row.respaldoPdf != null">
                                    <div class="row">
                                        <button type="button" tooltip="Visualizar pdf respaldo" class="btn btn-sm btn-link waves-effect rounded-pill" title="Documento de soporte" (click)="visualizarPdf(row.respaldoPdf)">
                                        <i class="fas fa-file-pdf fa-lg"></i>
                                        <div class="text-center">
                                        <span (click)="visualizarPdf(row.respaldoPdf)">{{ row.respaldoPdf}}</span>
                                        </div>
                                        </button>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="row">
                                    <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Cumplimiento del hito" (click)="evaluacionHitos(row)">
                                    <i class="fas fa-chart-line fa-lg"></i>
                                    </button>
                                </div>
                            </td>

                            <td class="text-center">
                                <div class="row" *hasDenied="{ nivel: idSprNivel, app: constant.PROYECTOS }">
                                    <button *hasPermission="{ app: constant.PROYECTOS, permission: [constant.ACTUALIZAR] }" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="update(row)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button *hasPermission="{  app: constant.PROYECTOS, permission: [constant.BORRAR] }" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(row.idSprHito)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<jw-modal id="{{ fechasCumplimientoHitos }}">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 12%">
        <div class="modal-content">
            <div class="modal-header pb-6">
                <button type="button" class="btn-close" (click)="modal.closeId (fechasCumplimientoHitos)" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <div class="card-header mb-2">
                    <div class="form-group row mb-2">
                        <div class="pservices text-justify">
                            <span><b>Hito:</b>{{ nombreHito }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="modal-body px-5">
                    <form action="#" [formGroup]="formHito" class="needs-validation">
                        <input type="hidden" id="idSprResumenEjecutivo" formControlName="idSprResumenEjecutivo" />
                        <div class="form-group row mb-2">
                            <div class="col col-md-3 text-md-center">
                                <label for="fechaComprometida" class="form-control-label text-md-right pt-1"><b>Fecha Comprometida:</b></label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input type="date" class="form-control" required="true" placeholder="fechaComprometida" formControlName="fechaComprometida" [ngClass]="{'is-invalid': this.formHito.get('fechaComprometida')?.errors && this.submitted,'is-valid': !this.formHito.get('fechaComprometida')?.errors, }"
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId(fechasCumplimientoHitos)">Cerrar</button>
                    <button type="button" class="btn btn-info" (click)="onSubmitFechas()">Guardar</button>
                </div>
            </div>
        </div>
    </div>
</jw-modal>
<!-- MENSAJE DE ELIMINAR -->
<jw-modal id="delete-hito" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>
<!-- MENSAJE DE ELIMINAR FIN -->

<!-- MODAL PARA CREAR Y EDITAR -->
<jw-modal id="{{ nameModal }}">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 6%" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{ nameModal1 }}</h3>
                <button type="button" class="btn-close" (click)="closeModalHito()" aria-label="Close"></button>
            </div>
            <div class="card mb-1">
                <div class="card-body px-5">
                    <form class="needs-validation" novalidate id="formHito" [formGroup]="formHito" autocomplete="off" (ngSubmit)="onSubmitHito(dataHito, true)">
                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right">
                                <label for="idSprHito" class="form-control-label text-md-right"><b>Nombre:</b></label>
                            </div>
                            <div class="col-12 col-md-10">
                                <textarea type="text" class="form-control" required="true" formControlName="nombre" placeholder="Nombre" maxlength="1500" rows="3" cols="30" [ngClass]="{ 'is-invalid': this.formHito.get('nombre')?.errors && this.formSubmitted,'is-valid': !this.formHito.get('nombre')?.errors,}">
                                </textarea>
                                <div class="col text-danger">
                                    <small class="font-italic" *ngIf="this.formHito.get('nombre')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right">
                                <label for="idSprCategoriaHito" class="form-control-label text-md-right pt-1"><b>Categoría de hitos:</b></label>
                            </div>
                            <div class="col-12 col-md-10">
                                <select id="idSprCategoriaHito" class="form-select col-12" formControlName="idSprCategoriaHito" [ngClass]="{'is-invalid': this.formHito.get('idSprCategoriaHito')?.errors && this.formSubmitted, 'is-valid': !this.formHito.get('idSprCategoriaHito')?.errors,}">
                                <option *ngFor="let categHito of dataCategoriaHitos" value="{{ categHito.idSprComun }}">
                                   {{ categHito.nombre }}
                                </option>
                                </select>
                                <div class="col text-danger">
                                    <small class="font-italic" *ngIf="this.formHito.get('idSprCategoriaHito')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right">
                                <label for="peso" class="form-control-label text-md-right pt-1"><b>Peso hito (%):</b></label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input type="number" min="0" max="100" maxlength="3" onkeydown="return false" name="peso" id="peso" placeholder="Solo caracteres Numericos" class="form-control" required="true" autocomplete="off" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)"
                                    formControlName="peso" autofocus placeholder="peso" [readOnly]="maximoHitosEtapa === 1" [style]="maximoHitosEtapa === 1 ? 'background-color: #e9e8e8;' : ''" [ngClass]="{'is-invalid': this.formHito.get('peso')?.errors && this.formSubmitted,'is-valid': !this.formHito.get('peso')?.errors && maximoHitosEtapa !==1 ,}"
                                    [readonly]="desahabilitarForm" />
                                <small class="invalid-feedback" *ngIf="this.formHito.get('peso')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>

                            <div class="col col-md-2 text-md-right">
                                <label for="fechaComprometida" class="form-control-label text-md-right"><b>Fecha comprometida:</b></label>
                            </div>
                            
                            <div *ngIf="idSprRolPrincipal != idRolAnalistaMetodologico" class="col-12 col-md-4">
                                <input type="date" class="form-control" required="true" placeholder="fechaComprometida" formControlName="fechaComprometida" style="background-color: #e9e8e8" [ngClass]="{'is-invalid': this.formHito.get('fechaComprometida')?.errors && this.formSubmitted,'is-valid': !this.formHito.get('fechaComprometida')?.errors,}"
                                    date>
                                <div class="col text-danger">
                                    <small class="font-italic" *ngIf="this.formHito.get('fechaComprometida')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                                    <span class="font-italic" *ngIf=" this.formHito.get('fechaComprometida').errors?.fechaInicio">La fecha debe estar comprendida entre{{this.formHito.get("fechaComprometida")?.errors.fechaInicio}} y {{ this.formHito.get("fechaComprometida")?.errors.fechaFin}}
                                    </span>
                                </div>
                            </div>

                            <div *ngIf="idSprRolPrincipal == idRolAnalistaMetodologico" class="col-12 col-md-4">
                                <input type="date" class="form-control" required="true" placeholder="fechaComprometida" formControlName="fechaComprometida" [ngClass]="{'is-invalid': this.formHito.get('fechaComprometida')?.errors && this.formSubmitted,'is-valid': !this.formHito.get('fechaComprometida')?.errors,}"
                                    date>
                                <div class="col text-danger">
                                    <small class="font-italic" *ngIf="this.formHito.get('fechaComprometida')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                                    <span class="font-italic" *ngIf=" this.formHito.get('fechaComprometida').errors?.fechaInicio">La fecha debe estar comprendida entre {{this.formHito.get("fechaComprometida")?.errors.fechaInicio }}y{{ this.formHito.get("fechaComprometida")?.errors.fechaFin }}
                                    </span>
                                </div>
                            </div>                 
                        </div>

                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right">
                                <label for="estado" class="col-form-label text-md-right"><b>Estado:</b></label>
                            </div>
                            <div class="col-12 col-md-4">
                                <select class="form-select" id="estado" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formHito.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formHito.get('estado')?.errors,}">
                                <option [value]="item.value" *ngFor="let item of selectItems">
                                {{ item.label }}
                                </option>
                                </select>
                                <div class="col text-danger">
                                    <small class="font-italic" *ngIf="this.formHito.get('estado')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                                </div>
                            </div>

                              
                            <div *ngIf="editPorcentajeTotal && maximoHitosEtapa !== 1" class="col col-md-2 text-md-right">
                                <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje restante (%):</b>
                                </label>
                            </div>
                            <div *ngIf="editPorcentajeTotal && maximoHitosEtapa !== 1" class="col-12 col-md-4">
                                <input class="form-control" disabled style="background-color: #e9e8e8" placeholder="{{ pesoRestante }} %" />
                            </div>

                            <div *ngIf="editPorcentaje" class="col col-md-2 text-md-right">
                                <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje restante. (%):</b>
                                </label>
                            </div>
                            <div *ngIf="editPorcentaje" class="col-12 col-md-4">
                                <input class="form-control" disabled style="background-color: #f5f4f4" placeholder="{{ pesoTotalEditado }} %" />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId(nameModal)">Cerrar</button>
                    <button type="button" class="btn btn-info" (click)="onSubmitHito(dataHito, true)">Guardar</button>
                </div>
            </div>
        </div>
    </div>
</jw-modal>

<jw-modal id="{{ nameModalDetalleHito }}">
    <div class="modal-dialog modal-lg" style="margin-top: 120px" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{ nameModal }}</h3>
                <button type="button" class="btn-close" (click)="closeModalCumpleHito()" aria-label="Close"></button>
            </div>
            <div class="card mb-1">
                <div class="card-body px-5">
                    <form class="needs-validation" novalidate id="formPlanAccion" id="formHito" [formGroup]="formHitoCumple" autocomplete="off">
                        <div class="container card-body mb-2 table-responsive" style=" background-color: #f2f3f4; border-radius: 20px; border: 1px solid #d3d4d6; box-shadow: 2px 2px 5px #999;">
                            <div class="form-group row mb-2">
                                <div class="col col-md-3">
                                    <b><span style="text-align: right; display: block">Hito:</span></b>
                                </div>
                                <div class="col col-md-8">
                                    <span>{{ nombre }}</span>
                                </div>
                            </div>

                            <div class="form-group row mb-2">
                                <div class="col col-md-3">
                                    <b><span style="text-align: right; display: block">Categoría del hito:</span></b>
                                </div>
                                <div class="col col-md-3">
                                    <span>{{ categoriaHito }}</span>
                                </div>

                                <div class="col col-md-3">
                                    <b><span style="text-align: right; display: block">Peso actividad:</span></b>
                                </div>
                                <div class="col col-md-3">
                                    <span>{{ peso }} %</span>
                                </div>
                            </div>

                            <div class="form-group row mb-2">
                                <div class="col col-md-3">
                                    <b><span style="text-align: right; display: block">Fecha comprometida:</span></b>
                                </div>
                                <div class="col col-md-3">
                                    <span>{{ fechaComprometida | date : "dd-MM-yyyy" }}</span>
                                </div>

                                <div class="col col-md-3">
                                    <b><span style="text-align: right; display: block">Fecha cumplimiento:</span></b>
                                </div>
                                <div class="col col-md-3">
                                    <span>{{ fechaEstimada | date : "dd-MM-yyyy" }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="shadow-sm p-2 mb-2 bg-body rounded py-0" *ngIf="desahabilitarForm">
                            <h3 class="text-center py-0" *ngIf="desahabilitarForm">CUMPLIMIENTO
                            </h3>
                        </div>

                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right">
                                <label for="avance">Avance</label>
                            </div>
                            <div class="col col-md-3">
                                <span>{{ avance }}</span>
                            </div>
                        </div>

                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right">
                                <label for="respaldoPdf" class="form-control-label text-md-right pt-1"><b>Respaldo pdf:</b></label>
                            </div>
                            <div class="col-12 col-md-10">
                                <input #myInput type="file" class="form-control" id="respaldoPdf" formControlName="respaldoPdf" required="true" (change)="capturarFile($event)" [ngClass]="{'is-invalid': this.formHitoCumple.get('respaldo')?.errors && this.formSubmitted,'is-valid': !this.formHitoCumple.get('respaldo')?.errors,}"
                                />
                                <small class="invalid-feedback" *ngIf="this.formHitoCumple.get('respaldoPdf')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>

                        <div class="modal-footer" id="modal">
                            <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal" (click)="modal.closeId(nameModalDetalleHito)">Cerrar</button>
                            <div *hasDenied="{ nivel: idSprNivel, app: constant.PROYECTOS }">
                                <button type="button" class="btn btn-info" (click)="subirArchivo()">Guardar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</jw-modal>